import styles from './AfegirBlocImatge.module.scss';
import { useState } from 'react';
import { useGetREDLStaticImageUrl } from '../../utils/hooks/useGetFileTreeUrl';

export default function AfegirBlocImatgeComponent({ data, onClick }) {
    const [paddingTop, setPaddingTop] = useState('0');
    const getREDLStaticImageUrl = useGetREDLStaticImageUrl();

    return (
        <div
            className={`${styles.redlAfegirBlocImatgeWrapper} ${onClick ? styles.redlAfegirBlocImatgeContainerClicable : ''}`}
            onClick={onClick}
            data-testid='REDL-add-block-image'
        >
            <div className={styles.redlAfegirBlocImatgeContainer} style={{ paddingTop }}>
                <h2 className={styles.rNomComponent}>{data?.title}</h2>
                <img
                    alt={`mòdul pre-configurat ${data?.thumbnail}`}
                    src={getREDLStaticImageUrl(data?.pathname, data?.thumbnail)}
                />
            </div>
        </div>
    );
}
